<header class="card-header border-bottom border-dashed" [ngClass]="layout.wide ? 'py-2 px-3' : 'p-2'">
  <div class="d-flex align-items-center gap-2">
    <img
      class="avatar-sm rounded-circle object-fit-cover flex-shrink-0"
      [src]="getContactImage($safeNavigationMigration(attendance?.contact))"
      alt=""
      (error)="onImageError($event)"
    />

    <div class="flex-grow-1 chat-header__shrink">
      <h2 class="h5 m-0 text-truncate" [title]="$safeNavigationMigration(attendance?.contact?.name)">
        {{ attendance?.contact?.name }}
      </h2>
      <div class="d-flex align-items-center gap-1 mt-1 position-relative">
        @if (shownStatuses.length) {
          <ul
            class="list-unstyled d-flex align-items-center gap-1 m-0 chat-header__shrink"
            [attr.aria-label]="'attendance.chatHeader.status.list' | translate"
          >
            @for (status of shownStatuses; track status.text) {
              <li class="d-flex chat-header__shrink">
                <span
                  class="badge campaign-badge d-inline-flex align-items-center gap-1 mw-100 overflow-hidden"
                  [ngClass]="status.variant"
                  [title]="status.title | translate: status.params"
                >
                  <i [ngClass]="status.icon"></i>
                  <span class="text-truncate">
                    {{ (layout.wide ? status.text : status.short) | translate: status.params }}
                  </span>
                </span>
              </li>
            }
          </ul>
        }
        @if (hiddenStatusCount > 0) {
          <button
            type="button"
            class="badge campaign-badge is-neutral flex-shrink-0"
            aria-haspopup="dialog"
            [attr.aria-expanded]="statusOpen"
            [attr.aria-controls]="statusId"
            [attr.aria-label]="'attendance.chatHeader.status.more' | translate: { count: statuses.length }"
            [matTooltip]="'attendance.chatHeader.status.more' | translate: { count: statuses.length }"
            (click)="toggleStatus($event)"
            (keydown.escape)="statusOpen = false"
          >
            +{{ hiddenStatusCount }}
          </button>
          <div
            class="dropdown-menu top-100 start-0 mt-2 p-3 chat-header__status-menu"
            role="dialog"
            [id]="statusId"
            [class.show]="statusOpen"
            [attr.aria-label]="'attendance.chatHeader.status.list' | translate"
            (click)="$event.stopPropagation()"
          >
            <h3 class="dropdown-header text-uppercase fw-bold font-11 p-0 mb-2">
              {{ "attendance.chatHeader.status.list" | translate }}
            </h3>
            <ul class="list-unstyled d-flex flex-column align-items-start gap-1 m-0">
              @for (status of statuses; track status.text) {
                <li class="mw-100">
                  <span class="badge campaign-badge d-inline-flex align-items-center gap-1 mw-100 text-wrap text-start" [ngClass]="status.variant">
                    <i [ngClass]="status.icon"></i>
                    <span>{{ status.text | translate: status.params }}</span>
                  </span>
                </li>
              }
            </ul>
          </div>
        }
        <span class="font-13 text-truncate chat-header__dept" [title]="deptAgent">{{ deptAgent }}</span>
      </div>
    </div>

    <div class="d-flex align-items-center gap-1 flex-shrink-0">
      @if (layout.inline) {
        <button
          type="button"
          class="btn btn-icon btn-sm rounded-circle"
          [ngClass]="searchOpen ? 'btn-soft-primary' : 'btn-link link-secondary'"
          [attr.aria-pressed]="searchOpen"
          [attr.aria-label]="'attendance.chatHeader.searchConversation' | translate"
          [matTooltip]="'attendance.chatHeader.searchConversation' | translate"
          (click)="trigger('search')"
        >
          <i class="ri-search-line font-18"></i>
        </button>
      }

      @if (layout.shown.length) {
        <div
          class="d-flex align-items-center gap-1"
          role="group"
          [attr.aria-label]="'attendance.chatHeader.pinnedGroup' | translate"
        >
          @for (action of layout.shown; track action.id) {
            <button
              type="button"
              class="btn btn-sm d-inline-flex align-items-center justify-content-center gap-1"
              [ngClass]="barButtonClass(action)"
              [attr.aria-pressed]="action.pressed"
              [attr.aria-label]="action.label | translate"
              [matTooltip]="action.label | translate"
              [disabled]="isBusy(action.id)"
              (click)="trigger(action.id)"
            >
              <i [ngClass]="iconOf(action)" [class.font-14]="showsLabel(action)" [class.font-16]="!showsLabel(action)"></i>
              @if (showsLabel(action)) {
                <span class="fw-semibold">{{ action.short | translate }}</span>
              }
            </button>
          }
        </div>
      }

      @if (isOpen) {
        <button
          type="button"
          class="btn btn-sm btn-soft-danger d-inline-flex align-items-center justify-content-center gap-1"
          [ngClass]="buttonShape(layout.closeLabeled)"
          [attr.aria-label]="'attendance.chatHeader.closeAttendance' | translate"
          [matTooltip]="'attendance.chatHeader.closeAttendance' | translate"
          (click)="trigger('close')"
        >
          <i class="ri-stop-circle-line" [ngClass]="layout.closeLabeled ? 'font-14' : 'font-16'"></i>
          @if (layout.closeLabeled) {
            <span class="fw-semibold">{{ "attendance.chat.close" | translate }}</span>
          }
        </button>
      }

      <div class="position-relative">
        <button
          #moreButton
          type="button"
          class="btn btn-icon btn-sm rounded-circle position-relative"
          [ngClass]="menuOpen ? 'btn-soft-primary' : 'btn-link link-secondary'"
          aria-haspopup="dialog"
          [attr.aria-expanded]="menuOpen"
          [attr.aria-controls]="menuId"
          [attr.aria-label]="moreLabel"
          [matTooltip]="moreLabel"
          (click)="toggleMenu($event)"
        >
          <i class="ri-more-2-fill font-18"></i>
          @if (layout.hidden.length) {
            <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary font-10" aria-hidden="true">
              {{ layout.hidden.length }}
            </span>
          }
        </button>

        <div
          #menu
          class="dropdown-menu top-100 end-0 mt-1 py-1 chat-header__menu"
          role="dialog"
          [id]="menuId"
          [class.show]="menuOpen"
          [attr.aria-label]="'attendance.chatHeader.moreActions' | translate"
          (click)="$event.stopPropagation()"
          (keydown.escape)="closeMenu()"
        >
          <div class="d-flex align-items-center justify-content-between gap-2 px-3 pt-1 pb-2 border-bottom">
            <div class="chat-header__shrink">
              @if (!layout.wide && deptAgent) {
                <div class="font-13 text-truncate mb-1">{{ deptAgent }}</div>
              }
              <div class="text-muted text-uppercase fw-bold font-11">
                {{ "attendance.panelList.columnProtocol" | translate }}
              </div>
              <div class="fw-bold">{{ attendance?.protocol }}</div>
            </div>
            <button
              type="button"
              class="btn btn-light btn-sm d-inline-flex align-items-center gap-1 flex-shrink-0"
              [class.text-success]="copied"
              [attr.aria-label]="(copied ? 'attendance.chatHeader.protocolCopied' : 'attendance.chatHeader.copyProtocol') | translate"
              (click)="copyProtocol()"
            >
              <i [ngClass]="copied ? 'ri-check-line' : 'ri-file-copy-line'"></i>
              <span>{{ (copied ? "attendance.chatHeader.copied" : "attendance.messageStatus.copy") | translate }}</span>
            </button>
          </div>

          <p class="d-flex align-items-start gap-2 mb-0 px-3 pt-2 pb-1 font-13">
            <i class="ri-pushpin-fill text-primary"></i>
            <span>{{ "attendance.chatHeader.pinHint" | translate }}</span>
          </p>

          @for (group of menuSections; track group.section; let first = $first) {
            @if (!first) {
              <div class="dropdown-divider my-1"></div>
            }
            <section [attr.aria-labelledby]="menuId + '-' + group.section">
              <h3 class="dropdown-header text-muted text-uppercase fw-bold font-11 px-3 pb-0" [id]="menuId + '-' + group.section">
                {{ group.label | translate }}
              </h3>
              <ul class="list-unstyled m-0">
                @for (entry of group.entries; track entry.id) {
                  <li class="d-flex align-items-center gap-1 pe-2">
                    <button
                      type="button"
                      class="dropdown-item d-flex align-items-center gap-2 pe-2"
                      [class.text-danger]="entry.danger"
                      [attr.aria-pressed]="entry.pressed"
                      [disabled]="isBusy(entry.id)"
                      (click)="trigger(entry.id)"
                    >
                      <i class="font-18" [ngClass]="iconOf(entry)"></i>
                      <span class="flex-grow-1 text-wrap">{{ entry.label | translate }}</span>
                      @if (entry.pressed !== undefined) {
                        <span class="badge campaign-badge" [ngClass]="entry.pressed ? 'is-run' : 'is-neutral'">
                          {{ (entry.pressed ? "wallet.list.badgeActive" : "attendance.chatHeader.action.aiPausedBadge") | translate }}
                        </span>
                      }
                      @if (isPinned(entry.id) && isHidden(entry.id)) {
                        <small class="text-muted text-nowrap">{{ "attendance.chatHeader.noRoom" | translate }}</small>
                      }
                    </button>
                    @if (entry.pinnable) {
                      <button
                        type="button"
                        class="btn btn-icon btn-sm rounded-circle"
                        [ngClass]="isPinned(entry.id) ? 'btn-soft-primary' : 'btn-link link-secondary'"
                        [attr.aria-pressed]="isPinned(entry.id)"
                        [attr.aria-label]="(isPinned(entry.id) ? 'attendance.chatHeader.unpin' : 'attendance.chatHeader.pin') | translate: { action: (entry.short | translate) }"
                        [matTooltip]="(isPinned(entry.id) ? 'attendance.chatHeader.unpin' : 'attendance.chatHeader.pin') | translate: { action: (entry.short | translate) }"
                        (click)="togglePin(entry.id)"
                      >
                        <i class="font-16" [ngClass]="isPinned(entry.id) ? 'ri-pushpin-fill' : 'ri-pushpin-line'"></i>
                      </button>
                    }
                  </li>
                }
              </ul>
            </section>
          }

          <div class="d-flex align-items-center justify-content-between gap-2 mt-1 px-3 pt-2 pb-1 border-top">
            <span class="font-12" role="status">{{ pinSummary }}</span>
            <button
              type="button"
              class="btn btn-link btn-sm p-0 fw-semibold text-nowrap"
              [disabled]="pinsAreDefault"
              (click)="restorePins()"
            >
              {{ "attendance.chatHeader.restoreDefault" | translate }}
            </button>
          </div>
        </div>
      </div>

      @if (layout.inline) {
        <span class="border-start align-self-stretch my-1" aria-hidden="true"></span>
        <button
          type="button"
          class="btn btn-icon btn-sm btn-link link-secondary rounded-circle"
          aria-controls="attendance-contact-panel"
          [attr.aria-expanded]="panelOpen"
          [attr.aria-label]="panelLabel | translate"
          [matTooltip]="panelLabel | translate"
          (click)="trigger('panel')"
        >
          <i class="font-18" [ngClass]="panelIcon"></i>
        </button>
      }
    </div>
  </div>
</header>

@if (searchOpen) {
  <div class="border-bottom" role="search" [ngClass]="layout.wide ? 'py-2 px-3' : 'p-2'">
    <form class="d-flex align-items-center gap-1" (ngSubmit)="trigger('searchSubmit')">
      <label class="visually-hidden" [for]="searchId">{{ "attendance.chatHeader.searchConversation" | translate }}</label>
      <div class="input-trend-search flex-grow-1 chat-header__shrink">
        <input
          #searchInput
          type="search"
          class="form-control"
          autocomplete="off"
          [id]="searchId"
          [value]="searchText"
          [placeholder]="'attendance.chatHeader.searchConversation' | translate"
          (input)="searchTextChange.emit(searchInput.value)"
          (keydown.escape)="trigger('search')"
        />
        <span class="ri-search-line search-icon"></span>
      </div>
      @if (searchTotal > 0) {
        <span class="font-13 text-nowrap px-1" role="status">
          <strong>{{ searchIndex + 1 }}</strong>
          {{ "attendance.chat.searchResultOf" | translate }}
          <strong>{{ searchTotal }}</strong>
        </span>
      }
      <button
        type="button"
        class="btn btn-icon btn-sm btn-link link-secondary rounded-circle"
        [disabled]="!searchTotal"
        [attr.aria-label]="'attendance.chatHeader.search.previous' | translate"
        [matTooltip]="'attendance.chatHeader.search.previous' | translate"
        (click)="trigger('searchPrevious')"
      >
        <i class="ri-arrow-up-line font-18"></i>
      </button>
      <button
        type="button"
        class="btn btn-icon btn-sm btn-link link-secondary rounded-circle"
        [disabled]="!searchTotal"
        [attr.aria-label]="'attendance.chatHeader.search.next' | translate"
        [matTooltip]="'attendance.chatHeader.search.next' | translate"
        (click)="trigger('searchNext')"
      >
        <i class="ri-arrow-down-line font-18"></i>
      </button>
      <button
        type="button"
        class="btn btn-light btn-sm d-inline-flex align-items-center justify-content-center gap-1"
        [ngClass]="buttonShape(layout.olderLabeled)"
        [attr.aria-label]="'attendance.chatHeader.search.older' | translate"
        [matTooltip]="'attendance.chatHeader.search.older' | translate"
        (click)="trigger('searchOlder')"
      >
        <i class="ri-history-line font-16"></i>
        @if (layout.olderLabeled) {
          <span>{{ "attendance.chatHeader.search.olderLabel" | translate }}</span>
        }
      </button>
      <button
        type="button"
        class="btn btn-icon btn-sm btn-link link-secondary rounded-circle"
        [attr.aria-label]="'attendance.chatHeader.search.close' | translate"
        [matTooltip]="'attendance.chatHeader.search.close' | translate"
        (click)="trigger('search')"
      >
        <i class="ri-close-line font-18"></i>
      </button>
    </form>
  </div>
}
